const apiBase = process.env.REACT_APP_API;

export const fetchLibraries = async () => {
  try {
    const response = await fetch(`${apiBase}/video/libraries`);
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error in fetchLibraries:', error);
    throw error;
  }
};